import { serviceHelper } from '../utils/serviceHelper'

export const getCampaignsByPartnerAndService = async (partner, service, calendarDate) => {
  const { month, year } = calendarDate
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.get(`/campaign/list/${partner}/${service}`, { params: { month, year, visibleTo: 'PARTNER' } })
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}`)
}
